module.exports = __webpack_public_path__ + "static/medograf-env1-29fe3f2156c87201d707603ddbc48d37.jpg";